import MagstimTableData from './MagstimTableData';
import { CurrentLang } from 'common';
import * as StringUtils from 'common/utils/StringUtils.js'

class MagstimTableDataClinicalAssessment extends MagstimTableData {

    getNamedValuePairs(data) {

        let tableData = [];
        //console.log("details getNamedValuePairs", this.props.data);

        tableData = [
            { name: CurrentLang().clinical_assessment_baseline, value: StringUtils.formatStringOrNoData(data.Baseline, CurrentLang().no_data) },
            { name: CurrentLang().clinical_assessment_last_assessment_rating, value: StringUtils.formatStringOrNoData(data.LastRatingScore, CurrentLang().no_data) },
            { name: CurrentLang().clinical_assessment_last_assessment, value: StringUtils.formatUtcDateOrNoData(data.LastAssessmentDate , CurrentLang().no_data) },
        ]

        return tableData;
    }
}

export default MagstimTableDataClinicalAssessment;
